"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("./utils/index");

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _cascade_tree = require("./utils/cascade_tree");

var _cascade_tree_props = require("./cascade_tree_props");

var _cascade_tree_classname_map = _interopRequireDefault(require("./config/cascade_tree_classname_map"));

var _icon_component = _interopRequireDefault(require("./component/icon_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CascadeTree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CascadeTree, _PureComponent);

  function CascadeTree(props) {
    var _this;

    _classCallCheck(this, CascadeTree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CascadeTree).call(this, props)); // 获取节点数据

    _defineProperty(_assertThisInitialized(_this), "isParentNodeCanSelect", function (value) {
      var _this$props = _this.props,
          singleParentNodeCanChoose = _this$props.singleParentNodeCanChoose,
          _this$props$parentNod = _this$props.parentNodeCanChoose,
          parentNodeCanChoose = _this$props$parentNod === void 0 ? true : _this$props$parentNod;

      var _this$getNodeTreeData = _this.getNodeTreeData(),
          _this$getNodeTreeData2 = _this$getNodeTreeData.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData2 === void 0 ? {} : _this$getNodeTreeData2;

      if ((0, _spauiUtils.isFunction)(singleParentNodeCanChoose)) {
        return singleParentNodeCanChoose(value, valueTreeNodeMap);
      }

      return parentNodeCanChoose;
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      var onScroll = _this.props.onScroll;
      var scrollTop = event.target.scrollTop;
      var visibleHeight = event.target.clientHeight;
      var scrollHeight = event.target.scrollHeight;

      if ((0, _spauiUtils.isFunction)(onScroll)) {
        onScroll(event, [scrollTop, scrollTop + visibleHeight], scrollHeight);
      }
    });

    _this.nullList();

    _this.getNodeTreeData(props);

    _this.state = {
      open: _this.getInitOpenValue(props)
    }; // 点击选择数据

    _this.handleChoose = _this.handleChoose.bind(_assertThisInitialized(_this)); // 展开回调

    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CascadeTree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // 重新计算树
      this.nodeTreeData = null; // 接收参数的时候重新计算

      this.getNodeTreeData(nextProps);

      if (nextProps.open !== 'undefined' && (0, _spauiUtils.isArray)(nextProps.open)) {
        this.setState({
          open: this.getInitOpenValue(nextProps)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    } // 需要回收清空的数据

  }, {
    key: "nullList",
    value: function nullList() {
      this.nodeTreeData = null;
      this.checkedData = []; // 展示选中的数据
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _cascade_tree_classname_map["default"], {}, classNameMap);
    } // 获取默认展开数据

  }, {
    key: "getInitOpenValue",
    value: function getInitOpenValue(props) {
      var _this$getNodeTreeData3 = this.getNodeTreeData(),
          _this$getNodeTreeData4 = _this$getNodeTreeData3.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData4 === void 0 ? {} : _this$getNodeTreeData4;

      var _props$fieldNames = props.fieldNames,
          fieldNames = _props$fieldNames === void 0 ? {} : _props$fieldNames,
          open = props.open,
          value = props.value;
      var _fieldNames$parentFie = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie === void 0 ? 'parent_id' : _fieldNames$parentFie;
      var result = [];
      var selectedValue = [];
      var parentValues = []; // 不管单选多选都转换成数组

      if (value && typeof open === 'undefined') {
        if ((0, _spauiUtils.isArray)(value)) {
          selectedValue = (0, _spauiUtils.cloneArray)(value);
        } else {
          selectedValue = [value];
        }
      } else if ((0, _spauiUtils.isArray)(open)) {
        // 已经存在open的，当成是选中的数据来换算出整个树的展示值
        selectedValue = (0, _spauiUtils.cloneArray)(open);
        selectedValue.map(function (item) {
          if ((item || typeof item === 'number') && (0, _spauiUtils.indexOf)(result, item) < 0) {
            result.push(item);
          }
        });
      } else if (open) {
        selectedValue = (0, _spauiUtils.cloneArray)([open]);
        selectedValue.map(function (item) {
          if ((item || typeof item === 'number') && (0, _spauiUtils.indexOf)(result, item) < 0) {
            result.push(item);
          }
        });
      }

      selectedValue.map(function (item) {
        if (valueTreeNodeMap[item]) {
          parentValues = (0, _cascade_tree.getParentValues)(valueTreeNodeMap[item], valueTreeNodeMap, parentFieldName, true);
          parentValues.map(function (parentValue) {
            if ((parentValue || typeof parentValue === 'number') && (0, _spauiUtils.indexOf)(result, parentValue) < 0) {
              result.push(parentValue);
            }

            return parentValue;
          });
        }

        return item;
      });
      return result;
    } // 渲染节点value

  }, {
    key: "setTreeNodeValue",
    value: function setTreeNodeValue() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _props$fieldNames2 = props.fieldNames,
          fieldNames = _props$fieldNames2 === void 0 ? {} : _props$fieldNames2;
      var _fieldNames$nodeField = fieldNames.nodeFieldName,
          nodeFieldName = _fieldNames$nodeField === void 0 ? 'options' : _fieldNames$nodeField,
          _fieldNames$valueFiel = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel === void 0 ? 'value' : _fieldNames$valueFiel,
          _fieldNames$parentFie2 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie2 === void 0 ? 'parent_id' : _fieldNames$parentFie2,
          _fieldNames$labelFiel = fieldNames.labelFieldName,
          labelFieldName = _fieldNames$labelFiel === void 0 ? 'desc' : _fieldNames$labelFiel,
          _fieldNames$disabledF = fieldNames.disabledFieldName,
          disabledFieldName = _fieldNames$disabledF === void 0 ? 'disabled' : _fieldNames$disabledF; // 渲染一层一层结构dom

      var renderTreeLevel = function renderTreeLevel() {
        var levelData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var level = arguments.length > 1 ? arguments[1] : undefined;

        if ((0, _spauiUtils.isArray)(levelData)) {
          levelData.map(function (item) {
            if (item) {
              if (typeof item[valueFieldName] !== 'undefined' && typeof item.value === 'undefined') {
                item.value = item[valueFieldName];
              }

              if (typeof item[parentFieldName] !== 'undefined' && typeof item.parent_id === 'undefined' && level > 0) {
                item.parent_id = item[parentFieldName];
              }

              if (typeof item[nodeFieldName] !== 'undefined' && typeof item.options === 'undefined') {
                item.options = item[nodeFieldName];
              }

              if (typeof item[labelFieldName] !== 'undefined' && typeof item.desc === 'undefined') {
                item.desc = item[labelFieldName];
              }

              if (typeof item[disabledFieldName] !== 'undefined' && typeof item.disabled === 'undefined') {
                item.disabled = item[disabledFieldName];
              } // 遍历子节点


              if ((0, _spauiUtils.isArray)(item[nodeFieldName]) && item[nodeFieldName].length > 0) {
                renderTreeLevel(item[nodeFieldName], level + 1);
              }
            }

            return item;
          });
        }
      };

      if ((0, _spauiUtils.isArray)(data)) {
        renderTreeLevel(data, 0);
      }
    } // 渲染树节点dom的位置

  }, {
    key: "renderTreeNodePosition",
    value: function renderTreeNodePosition() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _props$fieldNames3 = props.fieldNames,
          fieldNames = _props$fieldNames3 === void 0 ? {} : _props$fieldNames3;
      var _fieldNames$nodeField2 = fieldNames.nodeFieldName,
          nodeFieldName = _fieldNames$nodeField2 === void 0 ? 'options' : _fieldNames$nodeField2,
          _fieldNames$valueFiel2 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel2 === void 0 ? 'value' : _fieldNames$valueFiel2; // 渲染一层一层结构dom

      var renderTreeLevel = function renderTreeLevel() {
        var levelData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var level = arguments.length > 1 ? arguments[1] : undefined;

        if ((0, _spauiUtils.isArray)(levelData)) {
          levelData.map(function (item, index) {
            if (item) {
              // 如果没有值没法记录open数据，所以加多一个在tree数据中的定位
              if (!_this2.isEffectiveValue(item[valueFieldName], item)) {
                item._treePosition = "treePosition_".concat(level, "_").concat(index);
              } // 遍历子节点


              if ((0, _spauiUtils.isArray)(item[nodeFieldName]) && item[nodeFieldName].length > 0) {
                renderTreeLevel(item[nodeFieldName], level + 1);
              }
            }

            return item;
          });
        }
      };

      if ((0, _spauiUtils.isArray)(data)) {
        renderTreeLevel(data, 0);
      }
    } // 获取NodeTree的数据

  }, {
    key: "getNodeTreeData",
    value: function getNodeTreeData() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$fieldNames4 = props.fieldNames,
          fieldNames = _props$fieldNames4 === void 0 ? {} : _props$fieldNames4,
          _props$data = props.data,
          data = _props$data === void 0 ? [] : _props$data;
      var _fieldNames$valueFiel3 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel3 === void 0 ? '' : _fieldNames$valueFiel3;
      var result = {};
      var rootTreeNode = {};
      var childrenNodes = []; // 缓存下，然后在入口处做清除，避免多次遍历计算

      if (this.nodeTreeData) {
        result = this.nodeTreeData;
      } else {
        // 如果节点的选中值不是value，需要补充下
        if (valueFieldName !== 'value') {
          if ((0, _spauiUtils.isArray)(data) && data.length > 0) {
            this.setTreeNodeValue(data, props);
          }
        }

        result = _spauiUtils.nodeTree.genNodeTree(_objectSpread({}, props, {
          data: data
        }));

        if (_typeof(result) === 'object') {
          rootTreeNode = result.rootTreeNode || {};
          childrenNodes = rootTreeNode.childrenNodes || [];

          if (childrenNodes && childrenNodes.length > 0) {
            this.renderTreeNodePosition(childrenNodes);
          }
        }

        this.nodeTreeData = result;
      }

      return result;
    } // 清除掉已被选中的子节点数据
    // selectedValue 已经选中的节点数据
    // currentNodeValue 当前的节点

  }, {
    key: "clearSelectedChildValues",
    value: function clearSelectedChildValues() {
      var selectedValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var currentNodeValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props$fieldName = this.props.fieldNames,
          fieldNames = _this$props$fieldName === void 0 ? {} : _this$props$fieldName;
      var _fieldNames$valueFiel4 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel4 === void 0 ? 'value' : _fieldNames$valueFiel4;

      var _this$getNodeTreeData5 = this.getNodeTreeData(),
          _this$getNodeTreeData6 = _this$getNodeTreeData5.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData6 === void 0 ? {} : _this$getNodeTreeData6;

      var childValues = (0, _cascade_tree.getChildValues)(currentNodeValue, valueTreeNodeMap, valueFieldName);
      var result = [];
      selectedValue.map(function (item) {
        if ((0, _spauiUtils.indexOf)(childValues, item) < 0) {
          result.push(item);
        }

        return item;
      });
      return result;
    }
    /**
     * 该父节点是否可以选择
     *
     * @param {number|string} value 该节点的值
     * @memberof CascadeTree
     */

  }, {
    key: "handleChoose",
    value: function handleChoose(event) {
      var _this3 = this;

      var nodeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props2 = this.props,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? [] : _this$props2$value,
          _this$props2$fieldNam = _this$props2.fieldNames,
          fieldNames = _this$props2$fieldNam === void 0 ? {} : _this$props2$fieldNam,
          onChange = _this$props2.onChange,
          _this$props2$multiple = _this$props2.multiple,
          multiple = _this$props2$multiple === void 0 ? false : _this$props2$multiple,
          _this$props2$isAutoCh = _this$props2.isAutoCheckedParent,
          isAutoCheckedParent = _this$props2$isAutoCh === void 0 ? true : _this$props2$isAutoCh,
          isAutoCheckSubOption = _this$props2.isAutoCheckSubOption,
          valueType = _this$props2.valueType;
      var _fieldNames$valueFiel5 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel5 === void 0 ? 'value' : _fieldNames$valueFiel5,
          _fieldNames$parentFie3 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie3 === void 0 ? 'parent_id' : _fieldNames$parentFie3;
      var nodeValue = nodeData && nodeData[valueFieldName];

      var _this$getNodeTreeData7 = this.getNodeTreeData(),
          _this$getNodeTreeData8 = _this$getNodeTreeData7.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData8 === void 0 ? {} : _this$getNodeTreeData8;

      var newValue = [];
      var tempValue = [];
      var index = -1;
      var isParentSelected = false;
      var childrenNodes = null;
      var parentNodeValue = '';
      var parentValues = [];
      var parentNodeData = null; // 有值且有回调再处理

      if (this.isEffectiveValue(nodeValue, nodeData) && (0, _spauiUtils.isFunction)(onChange)) {
        if (multiple) {
          if ((0, _spauiUtils.isArray)(value)) {
            // 如果是开启不自动选中和清空子节点
            if (!isAutoCheckSubOption) {
              // 如果已经选中了部分子节点，然后现在选中父节点的情况下，这里相当于没有点击
              var childValues = (0, _cascade_tree.getChildValues)(nodeValue, valueTreeNodeMap, valueFieldName);
              var selectedSubOptionNumber = 0;
              value.forEach(function (valueItem) {
                if ((0, _spauiUtils.indexOf)(childValues, valueItem) > -1) {
                  selectedSubOptionNumber += 1;
                }
              });

              if (selectedSubOptionNumber > 0 && selectedSubOptionNumber < childValues.length) {
                return;
              }
            }

            if (nodeData) {
              parentNodeData = nodeData[parentFieldName] && valueTreeNodeMap[nodeData[parentFieldName]];
            } // 看看是否勾选完兄弟节点就全部选中了，那代表父节点就选中了


            if (parentNodeData) {
              childrenNodes = parentNodeData.childrenNodes || [];

              if (childrenNodes.length > 0) {
                // 如果只有一个节点，且不选中了，那父节点就不选中了
                if (childrenNodes.length === 1 && !event.target.checked) {
                  isParentSelected = false;
                } else {
                  // 先重置为true，如果有不存在勾选的，再改成false
                  isParentSelected = true;
                  childrenNodes.map(function (item) {
                    var childValue = '';

                    if (item) {
                      childValue = item[valueFieldName];

                      if (_this3.isEffectiveValue(childValue, item)) {
                        if (!((0, _spauiUtils.indexOf)(value, childValue) > -1 || nodeValue === childValue)) {
                          isParentSelected = false;
                        }
                      }
                    }

                    return item;
                  });
                }
              }
            } // 需要父节点选中了，就清除子节点，然后再加上父节点


            if (isParentSelected && isAutoCheckedParent && valueType !== 'child' && this.isParentNodeCanSelect(parentNodeData[valueFieldName])) {
              newValue = this.clearSelectedChildValues(value, parentNodeData[valueFieldName]);

              if ((0, _spauiUtils.indexOf)(newValue, parentNodeData[valueFieldName]) < 0) {
                newValue.push(parentNodeData[valueFieldName]);
              }
            } else {
              // 点击的发现父节点已经选中了
              if (this.parentIsSelected(nodeData)) {
                // 转化选择对应的子节点
                newValue = this.parentIsSelectedTransformSelectedChildValues(nodeData); // 清除自己

                newValue.splice((0, _spauiUtils.indexOf)(newValue, nodeValue), 1); // 再把子节点清掉

                newValue = this.clearSelectedChildValues(newValue, nodeValue); // 再把父节点都清除掉

                parentValues = (0, _cascade_tree.getParentValues)(nodeData, valueTreeNodeMap, parentFieldName);
                newValue.map(function (item) {
                  if ((item || typeof item === 'number') && (0, _spauiUtils.indexOf)(parentValues, item) < 0) {
                    tempValue.push(item);
                  }

                  return item;
                });
                newValue = tempValue;
              } else {
                // 不管选中没选中，点击后都需要清除子节点数据，然后再根据情况加上对应的节点
                newValue = this.clearSelectedChildValues(value, nodeValue);
                index = (0, _spauiUtils.indexOf)(newValue, nodeValue);

                if (index > -1) {
                  newValue.splice(index, 1);
                } else {
                  newValue.push(nodeValue);
                }
              }
            } // 最后判断下是不是有父节点选中的情况


            tempValue = (0, _spauiUtils.cloneArray)(newValue);
            newValue.map(function (item) {
              if (valueTreeNodeMap[item]) {
                if (valueTreeNodeMap[item].parentNode && valueTreeNodeMap[item].parentNode[valueFieldName]) {
                  parentNodeValue = valueTreeNodeMap[item].parentNode[valueFieldName];
                } else {
                  parentNodeValue = valueTreeNodeMap[item][parentFieldName];
                }
              }

              if (valueTreeNodeMap[item] && _this3.parentIsSelectedByChildNodes(newValue, valueTreeNodeMap[item]) && isAutoCheckedParent && valueType !== 'child' && _this3.isParentNodeCanSelect(parentNodeValue)) {
                // 先清除子节点
                tempValue = _this3.clearSelectedChildValues(tempValue, parentNodeValue); // 把父节点加上

                if ((0, _spauiUtils.indexOf)(tempValue, parentNodeValue) < 0) {
                  tempValue.push(parentNodeValue); // newValue也加上以便能够再次计算是否选中父节点

                  newValue.push(parentNodeValue);
                }
              }

              return item;
            });
            newValue = tempValue; // 是否为选择子节点，如果是的话，则回传最底层的子节点

            if (valueType === 'child') {
              var result = [];
              var finalResult = [];

              var addChildNodeValue = function addChildNodeValue() {
                var parentNodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var childNodeResult = arguments.length > 1 ? arguments[1] : undefined;
                var childrenNodes = parentNodeData.childrenNodes || [];

                if (parentNodeData.value) {
                  if (childrenNodes.length < 1) {
                    childNodeResult.push(parentNodeData.value);
                  } else {
                    childrenNodes.map(function (item) {
                      if (item.value && valueTreeNodeMap[item.value]) {
                        addChildNodeValue(valueTreeNodeMap[item.value], childNodeResult);
                      }

                      return item;
                    });
                  }
                }
              };

              newValue.map(function (item) {
                addChildNodeValue(valueTreeNodeMap[item] || {}, result);
              });
              result.map(function (item) {
                if (valueTreeNodeMap[item] && valueTreeNodeMap[item].value) {
                  finalResult.push(valueTreeNodeMap[item].value);
                } else {
                  finalResult.push(item);
                }

                return item;
              }); // 如果选择的是父节点，且当前节点的所有子节点都已经选中了，那么则取消这些节点的选中

              var _childValues = (0, _cascade_tree.getChildValues)(nodeValue, valueTreeNodeMap, valueFieldName, true);

              var isSelectAllSubOptions = _childValues.length > 0 && _childValues.every(function (item) {
                return value.includes(item);
              });

              if (isSelectAllSubOptions) {
                finalResult = finalResult.filter(function (item) {
                  return !_childValues.includes(item);
                });
              }

              newValue = finalResult;
            }

            onChange(event, (0, _index.arrayDistinct)(newValue), valueTreeNodeMap);
          }
        } else {
          if (value === nodeValue) {
            onChange(event, '', valueTreeNodeMap);
          } else {
            onChange(event, nodeValue, valueTreeNodeMap);
          }
        }
      }
    }
  }, {
    key: "handleOpen",
    value: function handleOpen(event) {
      var _this4 = this;

      var nodeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props3 = this.props,
          _this$props3$fieldNam = _this$props3.fieldNames,
          fieldNames = _this$props3$fieldNam === void 0 ? {} : _this$props3$fieldNam,
          onOpen = _this$props3.onOpen,
          propsOpen = _this$props3.open,
          asyncGetNodeData = _this$props3.asyncGetNodeData;
      var _fieldNames$valueFiel6 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel6 === void 0 ? 'value' : _fieldNames$valueFiel6,
          _fieldNames$nodeField3 = fieldNames.nodeFieldName,
          nodeFieldName = _fieldNames$nodeField3 === void 0 ? 'options' : _fieldNames$nodeField3;
      var _this$state$open = this.state.open,
          open = _this$state$open === void 0 ? [] : _this$state$open;
      var value = nodeData[valueFieldName];

      var _this$getNodeTreeData9 = this.getNodeTreeData(),
          _this$getNodeTreeData10 = _this$getNodeTreeData9.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData10 === void 0 ? {} : _this$getNodeTreeData10;

      var tempOpen = [];
      var index = -1;
      var newOpen = (0, _spauiUtils.cloneArray)(open);
      var childrenNodes = [];

      if (this.isEffectiveValue(value, nodeData)) {
        index = (0, _spauiUtils.indexOf)(open, value);

        if (index < 0) {
          newOpen.push(value);
        } else {
          newOpen.splice(index, 1); // 清除子节点

          newOpen = this.clearSelectedChildValues(newOpen, value);
        } // 如果数据是没有子节点的，那就是不能展开的，做下筛选


        newOpen.map(function (item) {
          var nodeItem = valueTreeNodeMap[item];
          var nodeFileValue = nodeItem && nodeItem[nodeFieldName] || [];

          if (nodeItem && (nodeFileValue.length > 0 || nodeData.load_option === 1 && asyncGetNodeData)) {
            tempOpen.push(item);
          } else if (!nodeItem) {
            // 不存在的应该是树结构的点要保留
            tempOpen.push(item);
          }

          return item;
        });
        newOpen = tempOpen;
      } else if (nodeData._treePosition) {
        index = (0, _spauiUtils.indexOf)(open, nodeData._treePosition);

        if (index < 0) {
          newOpen.push(nodeData._treePosition);
        } else {
          newOpen.splice(index, 1); // 清除子节点

          childrenNodes = nodeData.childrenNodes || [];
          childrenNodes.map(function (item) {
            if (item && item[valueFieldName]) {
              // 清除子节点
              newOpen = _this4.clearSelectedChildValues(newOpen, item[valueFieldName]);
              newOpen.splice((0, _spauiUtils.indexOf)(newOpen, item[valueFieldName]), 1);
            }

            return item;
          });
        }
      }

      if (typeof propsOpen === 'undefined') {
        this.setState({
          open: newOpen
        });
      }

      if ((0, _spauiUtils.isFunction)(onOpen)) {
        onOpen(event, newOpen, nodeData, valueTreeNodeMap);
      }
    } // 值是否有效

  }, {
    key: "isEffectiveValue",
    value: function isEffectiveValue(value) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (value || typeof value === 'number') && !data.not_allow_selected;
    } // 父节点是否选中

  }, {
    key: "parentIsSelected",
    value: function parentIsSelected() {
      var nodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props4 = this.props,
          _this$props4$fieldNam = _this$props4.fieldNames,
          fieldNames = _this$props4$fieldNam === void 0 ? {} : _this$props4$fieldNam,
          _this$props4$value = _this$props4.value,
          propsValue = _this$props4$value === void 0 ? [] : _this$props4$value;
      var _fieldNames$parentFie4 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie4 === void 0 ? 'parent_id' : _fieldNames$parentFie4;

      var _this$getNodeTreeData11 = this.getNodeTreeData(),
          _this$getNodeTreeData12 = _this$getNodeTreeData11.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData12 === void 0 ? {} : _this$getNodeTreeData12;

      var parentValues = (0, _cascade_tree.getParentValues)(nodeData, valueTreeNodeMap, parentFieldName);
      var result = false;

      if ((0, _spauiUtils.isArray)(parentValues)) {
        parentValues.map(function (item) {
          if ((item || typeof item === 'number') && !result && (0, _spauiUtils.indexOf)(propsValue, item) > -1) {
            result = true;
          }

          return item;
        });
      }

      return result;
    } // 是否有父节点禁用中

  }, {
    key: "parentIsDisabled",
    value: function parentIsDisabled() {
      var nodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props$fieldName2 = this.props.fieldNames,
          fieldNames = _this$props$fieldName2 === void 0 ? {} : _this$props$fieldName2;
      var _fieldNames$parentFie5 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie5 === void 0 ? 'parent_id' : _fieldNames$parentFie5,
          _fieldNames$disabledF2 = fieldNames.disabledFieldName,
          disabledFieldName = _fieldNames$disabledF2 === void 0 ? 'disabled' : _fieldNames$disabledF2;

      var _this$getNodeTreeData13 = this.getNodeTreeData(),
          _this$getNodeTreeData14 = _this$getNodeTreeData13.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData14 === void 0 ? {} : _this$getNodeTreeData14;

      var parentValues = (0, _cascade_tree.getParentValues)(nodeData, valueTreeNodeMap, parentFieldName);
      var result = false;

      if ((0, _spauiUtils.isArray)(parentValues)) {
        parentValues.map(function (item) {
          var nodeItem = valueTreeNodeMap[item];

          if ((item || typeof item === 'number') && !result && nodeItem && nodeItem[disabledFieldName]) {
            result = true;
          }

          return item;
        });
      }

      return result;
    } // 根据子节点是否选中来判断父节点是否选中了

  }, {
    key: "parentIsSelectedByChildNodes",
    value: function parentIsSelectedByChildNodes(value) {
      var nodeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props$fieldName3 = this.props.fieldNames,
          fieldNames = _this$props$fieldName3 === void 0 ? {} : _this$props$fieldName3;
      var _fieldNames$parentFie6 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie6 === void 0 ? 'parent_id' : _fieldNames$parentFie6,
          _fieldNames$valueFiel7 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel7 === void 0 ? 'value' : _fieldNames$valueFiel7;

      var _this$getNodeTreeData15 = this.getNodeTreeData(),
          _this$getNodeTreeData16 = _this$getNodeTreeData15.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData16 === void 0 ? {} : _this$getNodeTreeData16;

      var parentValue = nodeData && nodeData[parentFieldName];
      var parentNodeData = parentValue && valueTreeNodeMap[parentValue] || null;
      var result = false;
      var childrenNodes = [];

      if ((0, _spauiUtils.isArray)(value) && parentNodeData) {
        if ((0, _spauiUtils.indexOf)(value, parentValue) > -1) {
          result = true;
        } else {
          childrenNodes = parentNodeData.childrenNodes || [];

          if (childrenNodes.length > 0) {
            result = true;
            childrenNodes.map(function (item) {
              if (item && (0, _spauiUtils.indexOf)(value, item[valueFieldName]) < 0) {
                result = false;
              }

              return item;
            });
          }
        }
      }

      return result;
    } // 发现父节点是选中的，转化为选中子节点

  }, {
    key: "parentIsSelectedTransformSelectedChildValues",
    value: function parentIsSelectedTransformSelectedChildValues() {
      var _this5 = this;

      var nodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props5 = this.props,
          _this$props5$fieldNam = _this$props5.fieldNames,
          fieldNames = _this$props5$fieldNam === void 0 ? {} : _this$props5$fieldNam,
          _this$props5$value = _this$props5.value,
          propsValue = _this$props5$value === void 0 ? [] : _this$props5$value;
      var _fieldNames$parentFie7 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie7 === void 0 ? 'parent_id' : _fieldNames$parentFie7,
          _fieldNames$valueFiel8 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel8 === void 0 ? '' : _fieldNames$valueFiel8;

      var _this$getNodeTreeData17 = this.getNodeTreeData(),
          _this$getNodeTreeData18 = _this$getNodeTreeData17.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData18 === void 0 ? {} : _this$getNodeTreeData18;

      var parentValues = (0, _cascade_tree.getParentValues)(nodeData, valueTreeNodeMap, parentFieldName);
      var nodeValue = nodeData[valueFieldName];
      var result = [];
      var selectedParentValue = '';
      var theSelectedParentIndex = -1;
      var childrenNodes = [];
      var parentNodeData = {}; // 先判断选中的是哪个父节点

      parentValues.map(function (item, index) {
        if ((0, _spauiUtils.indexOf)(propsValue, item) > -1 && !selectedParentValue) {
          selectedParentValue = item;
          theSelectedParentIndex = index;
        }

        return item;
      }); // 如果找到了，就把该父节点对应的子节点选中，其中该父节点的下一层只选兄弟节点

      if (selectedParentValue && valueTreeNodeMap[selectedParentValue] && this.isEffectiveValue(nodeValue, nodeData)) {
        // 排除掉对应的父节点
        result = (0, _spauiUtils.cloneArray)(propsValue);
        result.splice((0, _spauiUtils.indexOf)(propsValue, selectedParentValue), 1); // 把该父节点的下一层子节点都选中

        childrenNodes = valueTreeNodeMap[selectedParentValue].childrenNodes || [];
        childrenNodes.map(function (item) {
          var subNodeValue = '';

          if (item) {
            subNodeValue = item[valueFieldName];

            if (_this5.isEffectiveValue(subNodeValue, item) && (0, _spauiUtils.indexOf)(result, subNodeValue) < 0) {
              result.push(subNodeValue);
            }
          }

          return item;
        }); // 然后再把父节点都选中

        parentValues.map(function (item, index) {
          var theNodeValue = '';

          if ((item || typeof item === 'number') && index > theSelectedParentIndex) {
            theNodeValue = item[valueFieldName];

            if (_this5.isEffectiveValue(theNodeValue, item) && (0, _spauiUtils.indexOf)(result, theNodeValue) < 0) {
              result.push(theNodeValue);
            }
          }

          return item;
        }); // 再把该节点选中及其兄弟节点都选中

        parentNodeData = valueTreeNodeMap[nodeData[parentFieldName]] || {};
        childrenNodes = parentNodeData.childrenNodes || [];
        childrenNodes.map(function (item) {
          var subNodeValue = '';

          if (item) {
            subNodeValue = item[valueFieldName];

            if (_this5.isEffectiveValue(subNodeValue, item) && (0, _spauiUtils.indexOf)(result, subNodeValue) < 0) {
              result.push(subNodeValue);
            }
          }

          return item;
        });
      }

      return result;
    }
  }, {
    key: "haveChildIsSelected",
    value: function haveChildIsSelected() {
      var nodeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props6 = this.props,
          _this$props6$fieldNam = _this$props6.fieldNames,
          fieldNames = _this$props6$fieldNam === void 0 ? {} : _this$props6$fieldNam,
          _this$props6$value = _this$props6.value,
          propsValue = _this$props6$value === void 0 ? [] : _this$props6$value;
      var _fieldNames$valueFiel9 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel9 === void 0 ? 'value' : _fieldNames$valueFiel9;

      var _this$getNodeTreeData19 = this.getNodeTreeData(),
          _this$getNodeTreeData20 = _this$getNodeTreeData19.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData20 === void 0 ? {} : _this$getNodeTreeData20;

      var nodeValue = nodeData[valueFieldName];
      var childValues = (0, _cascade_tree.getChildValues)(nodeValue, valueTreeNodeMap, valueFieldName);
      var result = false;

      if ((0, _spauiUtils.isArray)(childValues)) {
        childValues.map(function (item) {
          if ((item || typeof item === 'number') && !result && (0, _spauiUtils.indexOf)(propsValue, item) > -1) {
            result = true;
          }

          return item;
        });
      }

      return result;
    } // 渲染树节点dom

  }, {
    key: "renderTreeNode",
    value: function renderTreeNode() {
      var _this6 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props7 = this.props,
          _this$props7$fieldNam = _this$props7.fieldNames,
          fieldNames = _this$props7$fieldNam === void 0 ? {} : _this$props7$fieldNam,
          ExpandIconComponent = _this$props7.ExpandIconComponent,
          _this$props7$value = _this$props7.value,
          propsValue = _this$props7$value === void 0 ? [] : _this$props7$value,
          _this$props7$multiple = _this$props7.multiple,
          multiple = _this$props7$multiple === void 0 ? false : _this$props7$multiple,
          TitleComponent = _this$props7.TitleComponent,
          CheckboxComponent = _this$props7.CheckboxComponent,
          RadioComponent = _this$props7.RadioComponent,
          disabled = _this$props7.disabled,
          IconComponent = _this$props7.IconComponent,
          onClickItem = _this$props7.onClickItem,
          maxExpandOptionSize = _this$props7.maxExpandOptionSize,
          maxExpandStartLevel = _this$props7.maxExpandStartLevel,
          isAutoCheckSubOption = _this$props7.isAutoCheckSubOption,
          asyncGetNodeData = _this$props7.asyncGetNodeData,
          SortComponent = _this$props7.SortComponent,
          onSort = _this$props7.onSort,
          propsShowRadio = _this$props7.showRadio,
          setNodeTreeStyle = _this$props7.setNodeTreeStyle,
          setNodeTreeClassName = _this$props7.setNodeTreeClassName;
      var _fieldNames$nodeField4 = fieldNames.nodeFieldName,
          nodeFieldName = _fieldNames$nodeField4 === void 0 ? 'options' : _fieldNames$nodeField4,
          _fieldNames$valueFiel10 = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel10 === void 0 ? 'value' : _fieldNames$valueFiel10,
          _fieldNames$disabledF3 = fieldNames.disabledFieldName,
          disabledFieldName = _fieldNames$disabledF3 === void 0 ? 'disabled' : _fieldNames$disabledF3,
          _fieldNames$parentFie8 = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie8 === void 0 ? 'parent_id' : _fieldNames$parentFie8;
      var _this$state$open2 = this.state.open,
          stateOpen = _this$state$open2 === void 0 ? [] : _this$state$open2;

      var _this$getNodeTreeData21 = this.getNodeTreeData(),
          _this$getNodeTreeData22 = _this$getNodeTreeData21.valueTreeNodeMap,
          valueTreeNodeMap = _this$getNodeTreeData22 === void 0 ? {} : _this$getNodeTreeData22; // 渲染一层一层结构dom


      var renderTreeLevel = function renderTreeLevel() {
        var levelData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var levelResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var level = arguments.length > 2 ? arguments[2] : undefined;

        if ((0, _spauiUtils.isArray)(levelData) && (0, _spauiUtils.isArray)(levelResult)) {
          levelData.map(function (item, index) {
            var itemDisabled = !!(disabled || item[disabledFieldName]);
            var value = '';
            var nodeResult = null;
            var selected = false;
            var haveValue = false;
            var open = false;
            var childValues = [];
            var indeterminate = false;
            var showCheckbox = false;
            var showRadio = false;
            var onClickTitle;
            var onClickExpand;
            var onClickCheckbox;
            var onClickRadio;
            var iconComponentDom = null;
            var treePosition = '';

            if (item) {
              value = item[valueFieldName];
              treePosition = item._treePosition || '';
              haveValue = _this6.isEffectiveValue(value, item);
              showCheckbox = multiple && haveValue;
              showRadio = !multiple && propsShowRadio; // 遍历子节点

              if ((0, _spauiUtils.isArray)(item[nodeFieldName]) && item[nodeFieldName].length > 0) {
                nodeResult = [];
                renderTreeLevel(item[nodeFieldName], nodeResult, level + 1);
              } // 是否选中


              if (haveValue) {
                if (multiple) {
                  selected = (0, _spauiUtils.indexOf)(propsValue, value) > -1;

                  if (!selected && (item[parentFieldName] || typeof item[parentFieldName] === 'number')) {
                    // 父节点选中，并且设置父节点选中会选中子节点，那么此时子节点也是选中的
                    selected = isAutoCheckSubOption && _this6.parentIsSelected(item);
                  } // 没有选中的话，判断是否有子节点选中


                  if (!selected) {
                    childValues = (0, _cascade_tree.getChildValues)(value, valueTreeNodeMap, valueFieldName);
                    propsValue.map(function (propsValueItem) {
                      if (!indeterminate && (0, _spauiUtils.indexOf)(childValues, propsValueItem) > -1) {
                        indeterminate = true;
                      }

                      return propsValueItem;
                    });
                  }
                } else {
                  selected = propsValue === value;
                } // 展示被选中的数据，都放在this.checkedData里面，方便识别


                if (selected) {
                  _this6.checkedData.push(value);
                }
              } // 该节点是否能够展开


              var haveNodeResult = nodeResult && nodeResult.length > 0;
              var canExpand = haveNodeResult || item.load_option === 1 && asyncGetNodeData; // 当前节点的子选项是否正在异步加载数据

              var nodeValueData = valueTreeNodeMap[value];
              var isAsyncLoadingData = asyncGetNodeData && nodeValueData && nodeValueData.isLoading; // 是否展开

              if (canExpand) {
                if (haveValue) {
                  open = (0, _spauiUtils.indexOf)(stateOpen, value) > -1;
                } else {
                  open = (0, _spauiUtils.indexOf)(stateOpen, treePosition) > -1;
                } // 如果不给选择父节点，就要隐藏下


                if (!_this6.isParentNodeCanSelect(value)) {
                  showCheckbox = false;
                  itemDisabled = true;
                }
              } // 父节点是否禁用中


              if (!itemDisabled && _this6.parentIsDisabled(item)) {
                itemDisabled = true;
              } // 文案点击的回调


              onClickTitle = function onClickTitle(event) {
                // 有值且不禁用的时候，说明可以选择
                if (haveValue && !itemDisabled) {
                  _this6.handleChoose(event, item); // 既然不能选数据了，如果发现有子节点，那就变成可以点击做展开

                } else if (canExpand) {
                  _this6.handleOpen(event, item);
                }

                if ((0, _spauiUtils.isFunction)(onClickItem)) {
                  onClickItem(event, item, 'title');
                }
              };

              onClickExpand = function onClickExpand(event) {
                _this6.handleOpen(event, item);

                var isNeedAsyncGetNodeData = false;

                if (item.load_option === 1 && asyncGetNodeData && !(nodeResult && nodeResult.length > 0)) {
                  isNeedAsyncGetNodeData = true;
                }

                if ((0, _spauiUtils.isFunction)(onClickItem)) {
                  onClickItem(event, item, 'expand', valueTreeNodeMap[value], isNeedAsyncGetNodeData);
                }
              };

              onClickCheckbox = function onClickCheckbox(event) {
                if (!itemDisabled && (0, _spauiUtils.isFunction)(onClickItem)) {
                  onClickItem(event, item, 'checkbox');
                }
              };

              onClickRadio = function onClickRadio(event) {
                if (!itemDisabled && (0, _spauiUtils.isFunction)(onClickItem)) {
                  onClickItem(event, item, 'radio');
                }
              }; // 图标结构


              if (typeof IconComponent !== 'undefined') {
                if ((0, _spauiUtils.isReactNode)(IconComponent)) {
                  iconComponentDom = IconComponent;
                } else {
                  iconComponentDom = _react["default"].createElement(IconComponent, {
                    data: item,
                    selected: selected,
                    disabled: itemDisabled,
                    onChoose: function onChoose(event) {
                      return _this6.handleChoose(event, item);
                    },
                    onOpen: function onOpen(event) {
                      return _this6.handleOpen(event, item);
                    }
                  });
                }
              } // 如果设置了最大的展开数量，则超出的不进行显示


              if (maxExpandOptionSize && level >= maxExpandStartLevel && index >= maxExpandOptionSize) {
                return item;
              } else {
                var _haveNodeResult = nodeResult && nodeResult.length > 0;

                var nodeTreeStyle = {};
                var nodeTreeClassName = '';

                if ((0, _spauiUtils.isFunction)(setNodeTreeStyle)) {
                  nodeTreeStyle = setNodeTreeStyle(item);
                }

                if ((0, _spauiUtils.isFunction)(setNodeTreeClassName)) {
                  nodeTreeClassName = setNodeTreeClassName(item);
                }

                i += 1;
                levelResult.push(_react["default"].createElement(SortComponent, {
                  key: "".concat(value).concat(i),
                  className: (0, _classnames["default"])({
                    'spaui-cascade-tree-child-selected': _this6.haveChildIsSelected(item) && _haveNodeResult && !selected,
                    'spaui-cascade-tree-selected': selected,
                    'spaui-cascade-tree-can-choose': haveValue && !itemDisabled,
                    'spaui-cascade-tree-can-exapnd': canExpand
                  }),
                  parentId: item[parentFieldName],
                  index: index,
                  "data-value": value,
                  onSort: onSort
                }, _react["default"].createElement(ExpandIconComponent, {
                  haveData: canExpand,
                  open: open,
                  onOpen: onClickExpand,
                  data: item
                }), showCheckbox ? _react["default"].createElement(CheckboxComponent, {
                  onChange: function onChange(event) {
                    return _this6.handleChoose(event, item);
                  },
                  fieldNames: fieldNames,
                  checked: selected,
                  indeterminate: indeterminate,
                  data: item,
                  disabled: itemDisabled,
                  onClick: onClickCheckbox
                }) : null, showRadio ? _react["default"].createElement(RadioComponent, {
                  onChange: function onChange(event) {
                    return _this6.handleChoose(event, item);
                  },
                  fieldNames: fieldNames,
                  checked: selected,
                  data: item,
                  disabled: itemDisabled,
                  onClick: onClickRadio,
                  canCancelCheck: true
                }) : null, iconComponentDom, _react["default"].createElement(TitleComponent, {
                  className: (0, _classnames["default"])('spaui-cascade-tree-title', {
                    'spaui-cursor-pointer': canExpand && !showCheckbox,
                    disabled: itemDisabled
                  }),
                  onClick: onClickTitle,
                  fieldNames: fieldNames,
                  data: item,
                  checked: selected,
                  onOpen: onClickExpand,
                  treeNode: valueTreeNodeMap[value]
                }), isAsyncLoadingData ? _react["default"].createElement(_icon_component["default"], {
                  type: "loading-blue",
                  className: "loading-options-icon"
                }) : null, canExpand && open ? _react["default"].createElement("ul", {
                  style: nodeTreeStyle,
                  className: nodeTreeClassName
                }, nodeResult) : null));
              }
            }

            return item;
          });
        }
      };

      var result = null;
      var i = 0; // 重新渲染，标志选中的数据就重置

      this.checkedData = [];

      if ((0, _spauiUtils.isArray)(data)) {
        result = [];
        renderTreeLevel(data, result, 0);
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          multiple = _this$props8.multiple,
          value = _this$props8.value;

      var _this$getNodeTreeData23 = this.getNodeTreeData(),
          _this$getNodeTreeData24 = _this$getNodeTreeData23.rootTreeNode,
          rootTreeNode = _this$getNodeTreeData24 === void 0 ? {} : _this$getNodeTreeData24;

      var childrenNodes = rootTreeNode.childrenNodes || [];
      var classNameMap = this.getClassNameMap();
      var result = null;

      if (multiple) {
        if (!(0, _spauiUtils.isArray)(value)) {
          throw new Error("\u3010spaui-tree\u4E4BCascadeTree\u3011multiple=true\u65F6\uFF0Cvalue\u9700\u8981\u4E3A\u6570\u7EC4\uFF0C\u76EE\u524Dvalue=".concat(value));
        }
      } else {
        if ((0, _spauiUtils.isArray)(value)) {
          throw new Error("\u3010spaui-tree\u4E4BCascadeTree\u3011multiple=false\u65F6\uFF0Cvalue\u4E0D\u80FD\u4E3A\u6570\u7EC4\uFF0C\u76EE\u524Dvalue=".concat(value));
        }
      }

      if (childrenNodes && childrenNodes.length > 0) {
        result = _react["default"].createElement("ul", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
          className: classNameMap.CascadeTree
        }, CascadeTree), {
          onScroll: this.handleScroll
        }), this.renderTreeNode(childrenNodes));
      }

      return result;
    }
  }]);

  return CascadeTree;
}(_react.PureComponent); // 组件标记


_defineProperty(CascadeTree, "propTypes", _cascade_tree_props.propTypes);

_defineProperty(CascadeTree, "defaultProps", _cascade_tree_props.defaultProps);

(0, _spauiUtils.setComponentMark)(CascadeTree, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = CascadeTree;
exports["default"] = _default;